<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import ShippingManager from "@/components/profile/printParameters/shippingManager/ShippingManager.vue";
import LargeTabHeader from "@/components/common/tabs/LargeTabHeader.vue";

export default {
  components: {
    LargeTabHeader,
    ShippingManager,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      userSettings: state => state.settings
    }),
    ...mapGetters(['isLocked']),
    isShippingOptionsValid() {
      return this.userSettings.orderSchedule
    }
  },
  methods: {
    ...mapActions(['saveUserSettings']),
    handleClick() {
      this.loading = true
      this.saveUserSettings({
        orderSchedule: this.userSettings.orderSchedule,
      })
      .then(() => {
        this.$notify(this.$t('notification.save.success'), {type: 'success'})
      })
      .catch(() => {
        this.$notify(this.$t('notification.save.error'), {type: 'error'})
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<template>
  <v-container fluid>
    <!--    HEADER-->
    <LargeTabHeader
      :title="$t('component.documents.shipping.options')"
      :subtitle="$t('component.documents.shipping.description')"/>

    <v-divider></v-divider>

    <!--    SHIPPING MANAGER-->
    <v-row>
      <v-col>
        <v-card flat tile color="transparent">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <ShippingManager
                    v-if="$permissions.hasOrderAutocomplete"
                    v-model="userSettings.orderSchedule"
                    :locked="isLocked"/>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <!-- SAVE BUTTON-->
          <v-card-actions class="justify-center">
            <v-btn
              v-if="!isLocked"
              id="save-shipping-options-button"
              class="text-center px-8"
              color="primary"
              :loading="loading"
              :disabled="!isShippingOptionsValid"
              depressed
              @click.stop="handleClick">
              <v-icon class="me-2">mdi-check</v-icon>
              {{ $t('button.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
